import AuthLayout from "@container/layout/auth";
import EditCampaignContainer from "@container/agent-call-setup/edit";

export default function AgentCallSetupEditPage() {
    return (
        <AuthLayout>
            <EditCampaignContainer />
        </AuthLayout>
    );
}
